import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { CanalMidiaSocialMultiselectComponent } from './canal-midia-social-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        CanalMidiaSocialMultiselectComponent
    ],
    exports: [
        CanalMidiaSocialMultiselectComponent
    ]
})
export class CanalMidiaSocialmMultiselectModule { }
